import { useEffect, useRef, useState } from 'react';

/** After POST /game-answer: keep panel open for quick retries on wrong answer. */
export function shouldCloseGameAnswerPanel(data) {
  if (!data || typeof data !== 'object') return false;
  if (data.nextQuestionPrompt != null) return true;
  const text = String(data.result || '');
  if (/Väärin!?/i.test(text)) return false;
  if (/Tämä on jo ratkaistu/.test(text)) return false;
  if (/Vastaus vastaanotettu|Oikein! Sait pisteen!|Voitit!/.test(text)) return true;
  if (/Tapahtuma on päättynyt|Peli on päättynyt|Peli ei ole vielä käynnissä|Peli ei ole vielä alkanut/.test(text)) {
    return true;
  }
  return false;
}

/**
 * Inline “/vastaa” UI: parent should render after the prompt (e.g. emoji row + question) so it stays visible above the form.
 */
export default function GameAnswerInlinePanel({
  open,
  onClose,
  onSubmitAnswer,
  submitting,
}) {
  const [value, setValue] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) setValue('');
  }, [open]);

  useEffect(() => {
    if (!open || submitting) return;
    const t = requestAnimationFrame(() => {
      inputRef.current?.focus();
    });
    return () => cancelAnimationFrame(t);
  }, [open, submitting]);

  if (!open) return null;

  return (
    <div
      className="EventLivestream-game-vastaa-panel"
      role="dialog"
      aria-label="Lähetä vastaus"
    >
      <form
        className="EventLivestream-game-vastaa-form"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmitAnswer(value.trim());
        }}
      >
        <input
          ref={inputRef}
          type="text"
          className="EventLivestream-game-vastaa-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Vastaus"
          maxLength={500}
          disabled={submitting}
          autoComplete="off"
        />
        <div className="EventLivestream-game-vastaa-actions">
          <button type="submit" className="Button" disabled={submitting}>
            Lähetä
          </button>
          <button
            type="button"
            className="Button Button-secondary"
            onClick={onClose}
            disabled={submitting}
          >
            Peruuta
          </button>
        </div>
      </form>
    </div>
  );
}
